import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Snackbar,
  Divider,
  FormControl,
  InputLabel,
  Autocomplete,
  Typography,
  autocompleteClasses,
  InputAdornment,
  Tooltip,
  Dialog,
  DialogContent,
  TextareaAutosize,
  Menu,
  DialogTitle,
  DialogActions,
  IconButton,
} from "@mui/material";
import isEqual from "lodash/isEqual";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import {
  themeStyles,
  buttonStyle,
  SESSION_NOTE_97156,
  DELETE,
  UPDATE,
  SESSION_ID,
  SESSION_NOTE_97155,
  VIEW_SESSION_NOTE,
} from "../../../constants";

import "./index.css";
import { cleanText } from "../../../utils/textUtils";
import { Alert } from "@mui/material";
import { tokens } from "../../../theme";
import SignaturePad from "react-signature-canvas";
import { MultiInputTimeRangeField } from "@mui/x-date-pickers-pro";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axiosInstance from "../../../components/AxiosInstance";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import { useState, useEffect, useRef } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Formik, Field, Form } from "formik";
import SampleModal from "../../SamplePdFModal/index";
import dayjs from "dayjs";
import * as yup from "yup";
import { useContext } from "react";
import { AuthContext } from "../../SessionManagement/authContext";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../components/Header";
import LoadingIndicator from "../../Loader";
import { formatDate } from "@fullcalendar/core";
import { useTheme } from "@emotion/react";
import useSharedLink from "../../SharedLink";
import { useLocation } from "react-router-dom";
import { usePermissions } from "../../../Phase3/CheckPermission";
import { API_BASE_URL } from "../../../constants";
import { useAutoSave } from "../../../utils/AutoSave";
import { useSnackbar } from "../../../components/SnackBarProvider";
import { checkOwner } from "../SessionNoteCommon/ownerChecking";
const SessionNote97156 = ({ mode }) => {
  const theme = useTheme();
  const location = useLocation();
  const from = location.state?.from || "Unknown";
  const navigate = useNavigate();
  const sharedLink = useSharedLink();
  const [previouspagevalues, setPreviousPageValues] = useState(
    location.state?.previouspagevalues
  );
  const { openSnackbar } = useSnackbar();
  const { checkPermission, giveClients, giveStaff } = usePermissions();

  const [isDisabled, setIsDisabled] = useState(false);

  const [isFormDirty, setIsFormDirty] = useState(false); // Flag to track form changes

  const [showLeaveAlert, setShowLeaveAlert] = useState(false); // Flag to show custom leave alert
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get("sessionId");
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [supervisorSignatureImage, setSupervisorSignatureImage] = useState({
    image: null,
    date: null,
    exists: false,
  });
  const [formValues, setFormValues] = useState({});
  const latestFormValues = useRef(formValues);
  const [facilities, setFacilities] = useState([]);
  const clients = giveClients(SESSION_NOTE_97156, UPDATE);
  const staffs = giveStaff(SESSION_NOTE_97156, UPDATE);
  const [supervisor, setSupervisor] = useState([]);
  const [isloading, setIsloading] = useState(true);
  const [alertDanger, setAlertDanger] = useState(false);
  const [alertContentDanger, setAlertContentDanger] = useState("");
  const [info, setInfo] = useState(false);
  const [infoContent, setInfoContent] = useState("");
  const [initialValues, setInitialValues] = useState({});
  const [isSignaturePresent, setIsSignaturePresent] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const sessionType = [
    "Adaptive Behaviour Treatment",
    "Supervision",
    "Parent training",
    "Initial assessment",
    "Concurrent assessment",
    "Other",
  ];
  const placeOfService = ["Home", "School", "Other"];
  const diagnosisCode = ["F84.0", "Other"];
  const procedureCode = ["97151", "97153", "97156", "97155", "Other"];
  const moDifier = ["HM", "HN", "HO", "Other"];
  const parentOrGurdian = ["Parent", "Gurdian", "Other"];
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [modalSize, setModalSize] = useState("small");

  const handleImageModal = (pdf, size = "small") => {
    setSelectedPdf(pdf);
    setModalSize(size);
    setIsImageModalOpen(true);
  };
  const handleClose = () => {
    setAlertDanger(false);
  };
  const [sessionparticipantsState, setSessionParticipants] = useState({
    child: false,
    parent: true,
    bcba: true,
    behaviourtechnician: false,
    other: false,
  });

  const [moreInfoState, setMoreInfoState] = useState({
    optiona: false,
    optionb: false,
    otherinfocheckbox: false,
  });

  const [bcbaTrainingState, setBcbaTrainingState] = useState({
    rolePlayingModeling: false,
    generalizationTraining: false,
    naturalEnvironmentTraining: false,
    promptingStrategies: false,
    firstThenStatements: false,
    assistiveTechnology: false,
    shapingChaining: false,
    instructingOnPromptFading: false,
    visualSupportsTimerScheduleEtc: false,
    activitiesOfDailyLivingADLs: false,
    basicMandTraining: false,
    instructionalControlStrategies: false,
    instructingOnRewardsReinforcers: false,
    behaviorMomentum: false,
    others: false,
  });

  const [bcbaActivitiesState, setBcbaActivitiesState] = useState({
    observationOfParentChild: false,
    providingFeedback: false,
    assistiveTechnologies: false,
    instructionalDemonstrations: false,
    addressingConcernsQuestions: false,
    modelingDemonstratingStrategies: false,
  });

  const trainingLabels = {
    rolePlayingModeling: "Role Playing/Modeling",
    generalizationTraining: "Generalization Training",
    naturalEnvironmentTraining: "Natural Environment Training",
    promptingStrategies: "Prompting Strategies",
    firstThenStatements: "First/Then Statements",
    assistiveTechnology: "Assistive Technology",
    shapingChaining: "Shaping/Chaining",
    instructingOnPromptFading: "Instructing on Prompt Fading",
    visualSupportsTimerScheduleEtc: "Visual Supports (timer, schedule, etc.)",
    activitiesOfDailyLivingADLs: "Activities of Daily Living (ADLs)",
    basicMandTraining: "Basic Mand Training",
    instructionalControlStrategies: "Instructional Control Strategies",
    instructingOnRewardsReinforcers: "Instructing on Rewards/Reinforcers",
    behaviorMomentum: "Behavior Momentum",
    others: "*Others",
  };
  const sessionParticipantsLabels = {
    child: "Child",
    parent: "Parent",
    bcba: "BCBA",
    behaviourtechnician: "Behaviour Technician",
    other: "Other",
  };
  const activitiesLabels = {
    observationOfParentChild:
      "Observation of Parent/Child During Routine Interactions",
    providingFeedback: "Providing Feedback or Instructional Feedback",
    assistiveTechnologies: "Assistive Technologies",
    instructionalDemonstrations: "Instructional Demonstrations",
    addressingConcernsQuestions: "Addressing Concerns/Questions",
    modelingDemonstratingStrategies: "Modeling/Demonstrating Strategies",
  };
  const moreInfoLabels = {
    optiona: "BCBA Provided Parent Training",
    otherinfocheckbox: "Other",
  };
  const updateStateFromArray = (array, labels, setState) => {
    const stateUpdates = {};
    for (const item of array) {
      const key = Object.keys(labels).find((key) => labels[key] === item);
      console.log(labels);
      console.log(key);
      if (key) {
        stateUpdates[key] = true;
      }
    }
    setState((prevState) => ({ ...prevState, ...stateUpdates }));
    console.log(moreInfoState);
  };
  useEffect(() => {
    latestFormValues.current = formValues;
    console.log("Updated latestFormValues.current:", latestFormValues.current);
  }, [formValues]); // This will always trigger when `formValues` changes

  const disableFutureDates = (date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Disable dates that are before today
    return date > today;
  };

  const sigSupervisor = useRef(null);
  const handleGoBack = () => {
    if (
      !isEqual(
        JSON.parse(JSON.stringify(latestFormValues.current)),
        JSON.parse(localStorage.getItem("lastSavedData"))
      )
    ) {
      setShowLeaveAlert(true); // Show confirmation dialog if there are unsaved changes
    } else {
      const stateToSave = {
        formValues: previouspagevalues?.formValues,
        rows: previouspagevalues?.rows,
        staffs: previouspagevalues?.staffs,
        clients: previouspagevalues?.clients,
      };
      console.log(from + "from");
      console.log(stateToSave, "edit");
      if (from == VIEW_SESSION_NOTE)
        navigate("/viewsessionnotes", {
          state: { previouspagevalues: stateToSave },
        });
      else navigate(-1);
    }
  };

  // Handle user response to the leave alert
  const handleLeaveAlertResponse = (leave) => {
    setShowLeaveAlert(false); // Close the alert
    if (leave) {
      const stateToSave = {
        formValues: previouspagevalues?.formValues,
        rows: previouspagevalues?.rows,
        staffs: previouspagevalues?.staffs,
        clients: previouspagevalues?.clients,
      };
      console.log(from + "from");
      console.log(stateToSave, "edit");
      if (from == VIEW_SESSION_NOTE)
        navigate("/viewsessionnotes", {
          state: { previouspagevalues: stateToSave },
        });
      else navigate(-1);
    }
  };
  const clearSupervisorSignature = () => {
    setIsSignaturePresent(false);
    sigSupervisor.current.clear();
  };
  const handleInputChange = (event, setFieldValue) => {
    const cleanValue = cleanText(event.target.value);
    setFieldValue(event.target.name, cleanValue);
    handleFieldChange(cleanValue, event.target.name, initialValues);
  };
  const handleFieldChange = (newValue, fieldName, values) => {
    setIsFormDirty((prev) => newValue !== values[fieldName]);
    setFormValues((prevValues) => ({
      ...prevValues,
      [fieldName]: newValue,
    }));
  };
  const handleSessionParticipants = (event) => {
    const newState = {
      ...sessionparticipantsState,
      [event.target.name]: event.target.checked,
    };
    setSessionParticipants(newState);
    setFormValues((prevValues) => ({
      ...prevValues,
      sessionparticipants: Object.entries(newState)
        .filter(([_, value]) => value) // Only include checked items
        .map(([key]) => sessionParticipantsLabels?.[key] || key) // Fallback to key if mapper is undefined
        .join(";"),
    }));
  };

  const handleMoreInformation = (event) => {
    const newState = {
      ...moreInfoState,
      [event.target.name]: event.target.checked,
    };
    setMoreInfoState(newState);
    setFormValues((prevValues) => ({
      ...prevValues,
      trainingprovidedby: Object.entries(newState)
        .filter(([_, value]) => value) // Only include checked items
        .map(([key]) => moreInfoLabels?.[key] || key) // Fallback to key if mapper is undefined
        .join(";"),
    }));
  };

  const handleBcbaTrainingChange = (event) => {
    const newState = {
      ...bcbaTrainingState,
      [event.target.name]: event.target.checked,
    };
    setBcbaTrainingState(newState);
    setFormValues((prevValues) => ({
      ...prevValues,
      bcbastrategiesapplied: Object.entries(newState)
        .filter(([_, value]) => value) // Only include checked items
        .map(([key]) => trainingLabels?.[key] || key) // Fallback to key if mapper is undefined
        .join(";"),
    }));
  };
  const handleBcbaActivitiesChange = (event) => {
    const newState = {
      ...bcbaActivitiesState,
      [event.target.name]: event.target.checked,
    };
    setBcbaActivitiesState(newState);
    setFormValues((prevValues) => ({
      ...prevValues,
      bcbaactivitiesperformed: Object.entries(newState)
        .filter(([_, value]) => value) // Only include checked items
        .map(([key]) => activitiesLabels?.[key] || key) // Fallback to key if mapper is undefined
        .join(";"),
    }));
  };

  const handleSupervisorSignature = () => {
    if (sigSupervisor.current.isEmpty()) {
      setIsSignaturePresent(false); // Mark signature as not present
    } else {
      setIsSignaturePresent(true); // Mark signature as present
    }
  };
  const handleDeleteSignature = async (signatureType) => {
    const isConfirmed = window.confirm(
      "Are you sure want to delete this signature? This action cannot be undone."
    );

    if (!isConfirmed) return; // Exit if user cancels

    try {
      // API call to delete the signature
      await axiosInstance.post(API_BASE_URL + "/api/deleteSignature", {
        signaturetype: signatureType,
        sessionnoteid: sessionId,
        procedurecode: "97156",
        // Assuming sessionId is available in the component
      });

      setSupervisorSignatureImage({
        image: null,
        date: null,
        exists: false,
      });
      handleFieldChange(false, "supervisorsignatureexist", initialValues);
      handleFieldChange(null, "supervisorsignaturefilename", initialValues);
      handleFieldChange(null, "supervisorsignaturedate", initialValues);

      handleFieldChange("Draft", "sessionstatus", initialValues);
      openSnackbar("Signature deleted successfully", "success");
    } catch (error) {
      openSnackbar(error, "error");
      console.error("Error deleting signature:", error);
    }
  };
  const getEndPoint = (payload) => {
    if (localStorage.getItem(SESSION_ID)) {
      payload.id = localStorage.getItem(SESSION_ID);

      return sharedLink + "/updatesessionnote";
    }
    return sharedLink + "/addsessionnote";
  };
  useEffect(() => {
    const initializeSessionAndFetchData = async () => {
      try {
        setIsloading(true);

        // Clear any existing session ID from localStorage
        const savedSessionId = localStorage.getItem(SESSION_ID);
        if (savedSessionId) {
          localStorage.removeItem(SESSION_ID);
          localStorage.removeItem("lastSavedData");
        }

        console.log(mode, "mode");

        // If the mode is UPDATE, store session ID and fetch initial values
        if (mode === UPDATE) {
          localStorage.setItem(SESSION_ID, sessionId);
        }
        await fetchData();

        setIsloading(false);
      } catch (error) {
        console.error("Error initializing session and fetching data:", error);
        setIsloading(false);
      }
    };

    initializeSessionAndFetchData();
    console.log("hi");
  }, []);
  const fetchData = async () => {
    try {
      const userRole = localStorage.getItem("role");

      // Fetch supervisor and facility data
      const [supervisorResponse, facilitiesResponse] = await Promise.all([
        axiosInstance.post(
          sharedLink + "/roles/supervisorofrole",
          { role: userRole },
          { withCredentials: true }
        ),
        axiosInstance.post(sharedLink + "/viewallfacility", {
          withCredentials: true,
        }),
      ]);

      setSupervisor(supervisorResponse.data);
      setFacilities(facilitiesResponse.data);

      if (mode === UPDATE) {
        const sessionResponse = await axiosInstance.post(
          sharedLink + "/viewasessionnote",
          {
            id: sessionId,
            procedurecode: "97156",
          },
          { withCredentials: true }
        );

        const initialValues = {
          id: sessionId,
          facilityid: {
            id: sessionResponse.data[0].facilityId,
            facilityName: sessionResponse.data[0].facilityName,
          },
          clientid: {
            id: sessionResponse.data[0].clientId,
            firstName: sessionResponse.data[0].clientFirstName,
            lastName: sessionResponse.data[0].clientLastName,
          },
          staffid: {
            id: sessionResponse.data[0].staffId,
            firstName: sessionResponse.data[0].staffFirstName,
            lastName: sessionResponse.data[0].staffLastName,
          },
          supervisorid: {
            id: sessionResponse.data[0].supervisorId,
            name:
              sessionResponse.data[0].supervisorFirstName +
              " " +
              sessionResponse.data[0].supervisorLastName,
          },
          insurancename: sessionResponse.data[0].insuranceName,
          insurancepolicynumber: sessionResponse.data[0].insurancePolicyNumber,

          sessiondate: dayjs(sessionResponse.data[0].sessionDate),

          sessiontype: sessionResponse.data[0].sessionType,
          placeofservicecode: sessionResponse.data[0].placeOfServiceCode,
          otherplaceofservice: sessionResponse.data[0].otherPlaceOfService,
          modifier: sessionResponse.data[0].modifier,
          diagnosiscode1: sessionResponse.data[0].diagnosisCode1,
          otherdiagnosiscode: sessionResponse.data[0].otherDiagnosisCode,
          procedurecode: "97156",

          othersessionparticipants:
            sessionResponse.data[0].otherSessionParticipants,

          sessionsummary: sessionResponse.data[0].sessionSummary,

          parentorgurdianname: sessionResponse.data[0].parentOrGurdianName,

          supervisorsignaturefilename: "",
          supervisorsignaturedate: null,
          sessionstatus: sessionResponse.data[0].sessionStatus,
          supervisorsignatureexist:
            sessionResponse.data[0].supervisorSignatureExist,
          parentorcaregivertitle:
            sessionResponse.data[0].parentOrCaregiverTitle,
          othertrainingprovided: sessionResponse.data[0].otherTrainingProvided,
          planfornextsession: sessionResponse.data[0].planForNextVisit,
          otherbcbasapplied: sessionResponse.data[0].otherBcbasApplied,
          traininggoaladdressed: sessionResponse.data[0].trainingGoalAddressed,
          parentresponse: sessionResponse.data[0].parentResponse,
          barriersduringsession: sessionResponse.data[0].barriersDuringSession,
          supervisorImage: null,
        };
        if (sessionResponse.data[0].supervisorSignatureFileName != null) {
          setSupervisorSignatureImage({
            image: sessionResponse.data[0].supervisorSignatureFileName
              ? `data:image/png;base64,${sessionResponse.data[0].supervisorSignatureFileName}`
              : null,
            date: sessionResponse.data[0].supervisorSignatureDate
              ? dayjs(sessionResponse.data[0].supervisorSignatureDate)
              : null,
            exists: sessionResponse.data[0].supervisorSignatureExist,
          });
        }
        const currentPayload = {
          ...initialValues,
          staffid: sessionResponse.data[0].staffId,
          clientid: sessionResponse.data[0].clientId,
          supervisorid: sessionResponse.data[0].supervisorId,
          facilityid: sessionResponse.data[0].facilityId,
          sessionstarttime: sessionResponse.data[0].sessionStartTime,
          sessionendtime: sessionResponse.data[0].sessionEndTime,
          sessionparticipants: (
            sessionResponse.data[0].sessionParticipants || []
          ).join(";"),
          bcbaactivitiesperformed: (
            sessionResponse.data[0].bcbaActivitiesPerformed || []
          ).join(";"),
          trainingprovidedby: (
            sessionResponse.data[0].trainingProvidedBy || []
          ).join(";"),
          bcbastrategiesapplied: (
            sessionResponse.data[0].bcbaStrategiesApplied || []
          ).join(";"),
        };
        setFormValues(currentPayload);
        setIsDisabled(
          checkPermission(
            SESSION_NOTE_97156,
            UPDATE,
            checkOwner({ staffid: { id: sessionResponse.data[0].staffId } })
          ) == false
        );
        await localStorage.setItem(
          "lastSavedData",
          JSON.stringify(currentPayload)
        );
        const convert = (time12Hour) => {
          const [hour, minutePart] = time12Hour.split(":");
          const [minute, period] = minutePart.split(" ");

          let hour24 = parseInt(hour, 10);
          if (period === "PM" && hour24 !== 12) {
            hour24 += 12;
          } else if (period === "AM" && hour24 === 12) {
            hour24 = 0;
          }

          return `${String(hour24).padStart(2, "0")}:${minute}`;
        };

        const start = convert(sessionResponse.data[0].sessionStartTime);
        const end = convert(sessionResponse.data[0].sessionEndTime);

        initialValues.sessiontime = [
          moment(`Mon Oct 30 2023 ${start}:00`, "ddd MMM DD YYYY HH:mm:ss"),
          moment(`Mon Oct 30 2023 ${end}:00`, "ddd MMM DD YYYY HH:mm:ss"),
        ];
        updateStateFromArray(
          sessionResponse.data[0].bcbaActivitiesPerformed,
          activitiesLabels,
          setBcbaActivitiesState
        );
        updateStateFromArray(
          sessionResponse.data[0].bcbaStrategiesApplied,
          trainingLabels,
          setBcbaTrainingState
        );

        updateStateFromArray(
          sessionResponse.data[0].sessionParticipants,
          sessionParticipantsLabels,
          setSessionParticipants
        );
        updateStateFromArray(
          sessionResponse.data[0].trainingProvidedBy,
          moreInfoLabels,
          setMoreInfoState
        );
        setInitialValues(initialValues);
      } else {
        const initialValues = {
          facilityid: "",
          clientid: "",
          staffid: {
            id: localStorage.getItem("userId"),
            firstName: localStorage.getItem("username"),
            lastName: "",
          },
          insurancename: "",
          insurancepolicynumber: "",
          supervisorid: "",
          sessiondate: dayjs().format("YYYY-MM-DD"), // Default session date set to today
          sessionstarttime: null,
          sessionendtime: "",
          sessiontype: "",
          placeofservicecode: "",
          otherplaceofservice: "",
          modifier: "HO",
          diagnosiscode1: "",
          otherdiagnosiscode: "",
          procedurecode: "97156",
          sessionparticipants: "",
          othersessionparticipants: "",
          planfornextsession: "",
          sessionsummary: "",

          parentorgurdianname: "",

          supervisorsignaturefilename: "",
          supervisorsignaturedate: null,
          sessionstatus: "Draft",

          supervisorsignatureexist: false,
          parentorcaregivertitle: "",
          trainingprovidedby: "",
          othertrainingprovided: "",
          bcbastrategiesapplied: "",
          otherbcbasapplied: "",
          bcbaactivitiesperformed: "",
          traininggoaladdressed: "",
          parentresponse: "",
          barriersduringsession: "",
        };
        setFormValues({
          ...initialValues,
          sessionstatus: "Draft",
          staffid: localStorage.getItem("userId"),
        });
        await localStorage.setItem(
          "lastSavedData",
          JSON.stringify({
            ...initialValues,
            sessionstatus: "Draft",
            staffid: localStorage.getItem("userId"),
          })
        );
        setInitialValues({ ...initialValues, sessiontime: [null, null] });
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      setSnackbar({
        open: true,
        message: "Failed to fetch data",
        severity: "error",
      });
    }
    console.log(initialValues, "INITIALVALUES");
  };
  const handleApprove = (formData, { resetForm }) => {
    console.log("approve");
    if (handleErrors(formData)) {
      return;
    }
    const payload = handleData(formData);
    console.log("payload", payload);
    if (payload === null) {
      return;
    }
    if (
      !payload.supervisorsignatureexist &&
      !payload.supervisorsignaturefilename
    ) {
      setSnackbar({
        open: true,
        message: "Supervisor signature is required",
        severity: "error",
      });
      return;
    }
    payload.sessionstatus = "Approved";
    setSnackbar({
      open: true,
      message: "Approving...",
      severity: "info",
    });
    handleFormSubmit(payload, { resetForm });
    console.log(payload, "sent");
  };
  const handleData = (formData) => {
    console.log("inside handle data");
    const formattedSessionDate = dayjs(formData.sessiondate).format(
      "YYYY-MM-DD"
    );

    var sessionpart =
      (sessionparticipantsState.child ? "Child;" : "") +
      (sessionparticipantsState.parent ? "Parent;" : "") +
      (sessionparticipantsState.bcba ? "BCBA;" : "") +
      (sessionparticipantsState.behaviourtechnician
        ? "Behaviour Technician;"
        : "") +
      (sessionparticipantsState.other ? "Other;" : "");

    console.log("sessionparticipants ", sessionpart);

    if (sessionpart === "") {
      setSnackbar({
        open: true,
        message: "Please Session Participants",
        severity: "error",
      });
      return null;
    }

    var moreDetails =
      (moreInfoState.optiona ? "BCBA Provided Parent Training;" : "") +
      (moreInfoState.otherinfocheckbox ? "Other;" : "");
    if (moreDetails === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the Training Provided By",
        severity: "error",
      });
      return null;
    }
    var bcbaTrainingDetails = Object.entries(bcbaTrainingState)
      .filter(([key, value]) => value)
      .map(([key]) => trainingLabels[key])
      .join("; ");

    if (bcbaTrainingDetails !== "") {
      bcbaTrainingDetails += ";";
    }

    // Concatenate selected BCBA Activities options
    var bcbaActivitiesDetails = Object.entries(bcbaActivitiesState)
      .filter(([key, value]) => value)
      .map(([key]) => activitiesLabels[key])
      .join("; ");
    if (bcbaActivitiesDetails !== "") {
      bcbaActivitiesDetails += ";";
    }

    const { sessiontime, ...otherValues } = formData;
    console.log("diag", formData.diagnosiscode1, bcbaTrainingState.others);
    const payload = {
      ...otherValues,
      sessiondate: formattedSessionDate,
      bcbastrategiesapplied: bcbaTrainingDetails,

      otherbcbasapplied:
        bcbaTrainingState.others === true ? formData.otherbcbasapplied : "",

      bcbaactivitiesperformed: bcbaActivitiesDetails,
      sessionparticipants: sessionpart,
      trainingprovidedby: moreDetails,
      othertrainingprovided: moreInfoState.otherinfocheckbox
        ? formData.othertrainingprovided
        : "",
      otherdiagnosiscode:
        formData.diagnosiscode1 == "Other" ? formData.otherdiagnosiscode : "",

      sessionendtime: formData.sessiontime[1].format("HH:mm:a"),
      sessionstarttime: formData.sessiontime[0].format("HH:mm:a"),
    };
    console.log("sending", payload);
    if (!supervisorSignatureImage.image && !sigSupervisor.current.isEmpty()) {
      payload.supervisorsignatureexist = false; // Assuming this should be true here
      payload.supervisorsignaturefilename = sigSupervisor.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      payload.supervisorsignaturedate = dayjs(
        formData.supervisorsignaturedate
      ).format("YYYY-MM-DD");
    } else {
      payload.supervisorsignaturefilename = supervisorSignatureImage.image;
      payload.supervisorsignaturedate = supervisorSignatureImage.date;
    }

    return payload;
  };
  const handleErrors = (formData) => {
    if (!formData.sessiondate) {
      setSnackbar({
        open: true,
        message: "Please fill in the session date",
        severity: "error",
      });
      return true;
    }
    if (!formData.sessiontype) {
      setSnackbar({
        open: true,
        message: "Please fill in the session type",
        severity: "error",
      });
      return true;
    } else if (!formData.facilityid) {
      setSnackbar({
        open: true,
        message: "Please fill in the facility name",
        severity: "error",
      });
      return true;
    } else if (!formData.clientid) {
      setSnackbar({
        open: true,
        message: "Please fill in the client name",
        severity: "error",
      });
      return true;
    } else if (!formData.staffid) {
      setSnackbar({
        open: true,
        message: "Please fill in the staff name",
        severity: "error",
      });
      return true;
    } else if (!formData.supervisorid) {
      setSnackbar({
        open: true,
        message: "Please fill in the supervisor name",
        severity: "error",
      });
      return true;
    } else if (!formData.parentorgurdianname) {
      setSnackbar({
        open: true,
        message: "Please fill in the parent or guardian name",
        severity: "error",
      });
      return true;
    } else if (!formData.placeofservicecode) {
      setSnackbar({
        open: true,
        message: "Please fill in the place of service",
        severity: "error",
      });
      return true;
    } else if (!formData.modifier) {
      setSnackbar({
        open: true,
        message: "Please fill in the modifier",
        severity: "error",
      });
      return true;
    } else if (!formData.diagnosiscode1) {
      setSnackbar({
        open: true,
        message: "Please fill in the diagnosis code",
        severity: "error",
      });
      return true;
    } else if (
      !formData.sessiontime ||
      !formData.sessiontime[0] ||
      !formData.sessiontime[1] === null
    ) {
      setSnackbar({
        open: true,
        message: "Please fill in the session time",
        severity: "error",
      });
      return true;
    } else if (
      formData.sessiontime[0].format("HH:mm:a") == "Invalid Date" ||
      formData.sessiontime[1].format("HH:mm:a") == "Invalid Date" ||
      formData.sessiontime[0].format("HH:mm:a") >
        formData.sessiontime[1].format("HH:mm:a")
    ) {
      setSnackbar({
        open: true,
        message: "Please fill session time correctly",
        severity: "error",
      });
      return true;
    } else if (formData.placeofservicecode === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the place of service",
        severity: "error",
      });
      return true;
    } else if (
      formData.placeofservicecode == "Other" &&
      formData.otherplaceofservice == ""
    ) {
      setSnackbar({
        open: true,
        message: "Please fill in the other place of service",
        severity: "error",
      });
      return true;
    } else if (
      formData.diagnosiscode1 == "Other" &&
      formData.otherdiagnosiscode == ""
    ) {
      setSnackbar({
        open: true,
        message: "Please fill in the other diagnosis code",
        severity: "error",
      });
      return true;
    } else if (formData.modifier === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the modifier",
        severity: "error",
      });
      return true;
    } else if (formData.procedurecode === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the procedure code",
        severity: "error",
      });
      return true;
    } else if (formData.diagnosiscode1 === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the diagnosis code",
        severity: "error",
      });
      return true;
    } else if (formData.sessionsummary === "") {
      setSnackbar({
        open: true,
        message: "Please fill in the session summary",
        severity: "error",
      });
      return true;
    }
    if (
      !formData.supervisorsignatureexist &&
      !sigSupervisor.current.isEmpty() &&
      formData.supervisorsignaturedate === null
    ) {
      setSnackbar({
        open: true,
        message: "Please fill in the supervisor signature",
        severity: "error",
      });
      return true;
    }
    if (!formData.planfornextsession) {
      setSnackbar({
        open: true,
        message: "Please fill in the plan for next session",
        severity: "error",
      });
      return true;
    }
    if (!formData.parentorcaregivertitle) {
      setSnackbar({
        open: true,
        message: "Please fill in the parent or caregiver title",
        severity: "error",
      });
      return true;
    }
    if (!formData.traininggoaladdressed) {
      setSnackbar({
        open: true,
        message: "Please fill in the training goal addressed",
        severity: "error",
      });
      return true;
    }
    if (!formData.parentresponse) {
      setSnackbar({
        open: true,
        message: "Please fill in the parent response",
        severity: "error",
      });
      return true;
    }
    if (!formData.barriersduringsession) {
      setSnackbar({
        open: true,
        message: "Please fill in the barriers during session",
        severity: "error",
      });
      return true;
    }

    return false;
  };

  const checkRequiredFieldForDraft = (formData) => {
    if (!formData.sessiondate) {
      setSnackbar({
        open: true,
        message: "Please fill in the session date",
        severity: "error",
      });
      return true;
    } else if (
      !formData.sessiontime ||
      !formData.sessiontime[0] ||
      !formData.sessiontime[1] === null
    ) {
      setSnackbar({
        open: true,
        message: "Please fill in the session time",
        severity: "error",
      });
      return true;
    } else if (
      formData.sessiontime[0].format("HH:mm:a") == "Invalid Date" ||
      formData.sessiontime[1].format("HH:mm:a") == "Invalid Date" ||
      formData.sessiontime[0].format("HH:mm:a") >
        formData.sessiontime[1].format("HH:mm:a")
    ) {
      setSnackbar({
        open: true,
        message: "Please fill session time correctly",
        severity: "error",
      });
      return true;
    } else if (!formData.facilityid) {
      setSnackbar({
        open: true,
        message: "Please fill in the facility name",
        severity: "error",
      });
      return true;
    } else if (!formData.clientid) {
      setSnackbar({
        open: true,
        message: "Please fill in the client name",
        severity: "error",
      });
      return true;
    } else if (!formData.staffid) {
      setSnackbar({
        open: true,
        message: "Please fill in the staff name",
        severity: "error",
      });
      return true;
    } else if (!formData.supervisorid) {
      setSnackbar({
        open: true,
        message: "Please fill in the supervisor name",
        severity: "error",
      });
      return true;
    }
    return false;
  };
  const handleSaveAsDraft = (formData, { resetForm }) => {
    console.log("draft", formData);
    if (checkRequiredFieldForDraft(formData)) {
      return;
    }
    const payload = handleData(formData);
    if (payload === null) {
      return;
    }
    console.log(payload, "sent");
    // console.log(values);
    setSnackbar({
      open: true,
      message: "Saving as draft...",
      severity: "info",
    });
    payload.sessionstatus = "Draft";
    console.log(payload);
    handleFormSubmit(payload, { resetForm });

    // Add your logic for saving as draft
  };

  const handleFormSubmit = (payload, { resetForm }) => {
    axiosInstance
      .post(getEndPoint(payload), {
        ...payload,
        staffid: payload.staffid.id,
        supervisorid: payload.supervisorid.id,
        facilityid: payload.facilityid.id,
        clientid: payload.clientid.id,
      })
      .then((res) => {
        console.log("response", res);
        if (res.status === 200) {
          console.log("response hi", res);
          if (Array.isArray(res.data)) {
            console.log("response hi", res);
            setSnackbar({
              open: true,
              message: "Saved successfully",
              severity: "success",
            });

            resetOtherValues(payload, resetForm);
          }
        } else {
          setSnackbar({
            open: true,
            message: "Failed to save",
            severity: "error",
          });
        }
      })
      .catch((error) => {
        openSnackbar(error, "error");
      });
  };
  const resetOtherValues = async (values, resetForm) => {
    console.log(values, "in reset");
    if (mode == UPDATE) {
      setSupervisorSignatureImage({
        image: values.supervisorsignaturefilename,
        exists: values.supervisorsignatureexist,
        date: values.supervisorsignaturedate,
      });
      setFormValues({
        ...formValues,
        supervisorsignaturefilename: values.supervisorsignaturefilename,
        supervisorsignaturedate: values.supervisorsignaturedate,
        supervisorsignatureexist: values.supervisorsignatureexist,
        sessionstatus: values.sessionstatus,
      });
      await localStorage.setItem(
        "lastSavedData",
        JSON.stringify({
          ...formValues,
          supervisorsignaturefilename: values.supervisorsignaturefilename,
          supervisorsignaturedate: values.supervisorsignaturedate,
          supervisorsignatureexist: values.supervisorsignatureexist,
          sessionstatus: values.sessionstatus,
        })
      );
    }

    if (!isDisabled && sigSupervisor.current) clearSupervisorSignature();
    if (mode !== UPDATE) {
      resetForm();
      values.clientid = "";

      clearSupervisorSignature();
      setMoreInfoState({
        optiona: false,
        optionb: false,
        otherinfocheckbox: false,
      });
      setSessionParticipants({
        child: false,
        parent: false,
        bcba: false,
        behaviourtechnician: false,
        other: false,
      });
      setBcbaTrainingState({
        rolePlayingModeling: false,
        generalizationTraining: false,
        naturalEnvironmentTraining: false,
        promptingStrategies: false,
        firstThenStatements: false,
        assistiveTechnology: false,
        shapingChaining: false,
        instructingOnPromptFading: false,
        visualSupportsTimerScheduleEtc: false,
        activitiesOfDailyLivingADLs: false,
        basicMandTraining: false,
        instructionalControlStrategies: false,
        instructingOnRewardsReinforcers: false,
        behaviorMomentum: false,
        others: false,
      });
      setBcbaActivitiesState({
        observationOfParentChild: false,
        providingFeedback: false,
        assistiveTechnologies: false,
        instructionalDemonstrations: false,
        addressingConcernsQuestions: false,
        modelingDemonstratingStrategies: false,
      });
      setFormValues({});
      setIsFormDirty(false);
      localStorage.removeItem(SESSION_ID);
      localStorage.removeItem("lastSavedData");
    }
  };
  useAutoSave(
    latestFormValues.current,
    "/api/addsessionnote",
    "/api/updatesessionnote",
    SESSION_ID
  );
  if (isloading) {
    return <LoadingIndicator />;
  } else {
    return (
      <Box m="20px">
        <Dialog
          open={showLeaveAlert}
          onClose={() => setShowLeaveAlert(false)}
          aria-labelledby="unsaved-changes-dialog">
          <DialogTitle id="unsaved-changes-dialog">Unsaved Changes</DialogTitle>
          <DialogContent>
            Are you sure want to leave? Unsaved changes will be lost.
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => handleLeaveAlertResponse(false)}
              color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => handleLeaveAlertResponse(true)}
              color="secondary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}>
          <Alert
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}>
            {snackbar.message}
          </Alert>
        </Snackbar>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <Header
            title="Session Note (97156)"
            subtitle=""
            style={{ flexGrow: 1, textAlign: "center" }}
          />
          <br />
        </Box>
        <Formik
          enableReinitialize
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}>
          {({
            values,
            setFieldValue,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            resetForm,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}>
                <FormControl
                  fullWidth
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                  <Autocomplete
                    fullWidth
                    options={facilities}
                    getOptionLabel={(option) =>
                      `${option.facilityName} ${option.facilityNPI}`
                    }
                    value={values.facilityid || null}
                    autoHighlight
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Facility Name"
                        variant="filled"
                        className="animated-input"
                        inputProps={{
                          ...params.inputProps,
                          "aria-label": "Select Facility",
                        }}
                      />
                    )}
                    onChange={(event, newValue) => {
                      setFieldValue("facilityid", newValue ? newValue : "");
                      handleFieldChange(
                        newValue ? newValue.id : "",
                        "facilityid",
                        initialValues
                      );
                    }}
                    disabled={isDisabled}
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                  />
                </FormControl>

                <FormControl
                  fullWidth
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                  <Autocomplete
                    options={clients}
                    getOptionLabel={(option) =>
                      `${option.firstName} ${option.lastName} `
                    }
                    autoHighlight
                    value={values.clientid || null}
                    onChange={(event, newValue) => {
                      setFieldValue("clientid", newValue ? newValue : "");
                      setFieldValue(
                        "insurancename",
                        newValue ? newValue.insuranceName : ""
                      );
                      setFieldValue(
                        "insurancepolicynumber",
                        newValue ? newValue.policyNumber : ""
                      );
                      handleFieldChange(
                        newValue ? newValue.id : "",
                        "clientid",
                        initialValues
                      );
                      handleFieldChange(
                        newValue ? newValue.insuranceName : "",
                        "insurancename",
                        initialValues
                      );
                      handleFieldChange(
                        newValue ? newValue.policyNumber : "",
                        "insurancepolicynumber",
                        initialValues
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Client Name"
                        variant="filled"
                        className="animated-input"
                        required
                      />
                    )}
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                    disabled={isDisabled}
                  />
                </FormControl>

                <FormControl
                  fullWidth
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                  <Autocomplete
                    fullWidth
                    options={staffs}
                    getOptionLabel={(option) =>
                      `${option.firstName} ${option.lastName} `
                    }
                    value={values.staffid || null}
                    autoHighlight
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Staff Name"
                        variant="filled"
                        className="animated-input"
                        inputProps={{
                          ...params.inputProps,
                          "aria-label": "Select Staff Name",
                        }}
                      />
                    )}
                    onChange={(event, newValue) => {
                      setFieldValue("staffid", newValue ? newValue : "");
                      handleFieldChange(
                        newValue ? newValue.id : "",
                        "staffid",
                        initialValues
                      );
                    }}
                    disabled={isDisabled}
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                  />
                </FormControl>

                <FormControl
                  fullWidth
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                  <Autocomplete
                    options={supervisor}
                    getOptionLabel={(option) =>
                      `${option.name}` +
                      (option.role ? ` (${option.role}) ` : "")
                    }
                    autoHighlight
                    value={values.supervisorid || null}
                    onChange={(event, newValue) => {
                      setFieldValue("supervisorid", newValue ? newValue : "");
                      handleFieldChange(
                        newValue ? newValue.id : "",
                        "supervisorid",
                        initialValues
                      );
                    }}
                    disabled={isDisabled}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Supervisor Name"
                        variant="filled"
                        className="animated-input"
                        required
                      />
                    )}
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                  />
                </FormControl>

                <TextField
                  fullWidth
                  variant="filled"
                  className="animated-input"
                  label="Insurance Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  disabled
                  value={values.insurancename}
                  name="insurancename"
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  className="animated-input"
                  label="Insurance Policy Number"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  disabled
                  value={values.insurancepolicynumber}
                  name="insurancepolicynumber"
                  error={
                    !!touched.insurancepolicynumber &&
                    !!errors.insurancepolicynumber
                  }
                  helperText={
                    touched.insurancepolicynumber &&
                    errors.insurancepolicynumber
                  }
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                />
                <Autocomplete
                  fullWidth
                  autoHighlight
                  options={parentOrGurdian} // Array of parent or guardian names
                  getOptionLabel={(option) => option} // Assuming each option has a 'name' property
                  value={
                    parentOrGurdian.find(
                      (item) => item === values.parentorgurdianname
                    ) || ""
                  }
                  onChange={(event, newValue) => {
                    setFieldValue(
                      "parentorgurdianname",
                      newValue ? newValue : ""
                    );
                    handleFieldChange(
                      newValue ? newValue.id : "",
                      "parentorgurdianname",
                      initialValues
                    );
                  }}
                  disabled={isDisabled}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Parent or Guardian"
                      variant="filled"
                      className="animated-input"
                      required
                    />
                  )}
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                />
                <FormControl
                  fullWidth
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                  <Autocomplete
                    fullWidth
                    options={sessionType}
                    getOptionLabel={(option) => option} // Since options are strings
                    autoHighlight
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Session Type"
                        variant="filled"
                        className="animated-input"
                        required
                        inputProps={{
                          ...params.inputProps,
                          "aria-label": "Select Session Type",
                        }}
                      />
                    )}
                    value={values.sessiontype || null} // Fallback to null if no value is set
                    onChange={(event, newValue) => {
                      setFieldValue("sessiontype", newValue);
                      handleFieldChange(newValue, "sessiontype", initialValues);
                    }}
                    disabled={isDisabled}
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                  />
                </FormControl>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Session Date"
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                    fullWidth
                    variant="filled"
                    className="animated-input"
                    name="sessiondate"
                    required
                    value={
                      dayjs(values.sessiondate).isValid()
                        ? dayjs(values.sessiondate)
                        : null
                    }
                    onChange={(newValue) => {
                      setFieldValue(
                        "sessiondate",
                        newValue ? newValue.format("YYYY-MM-DD") : ""
                      );
                      handleFieldChange(
                        dayjs(newValue).format("YYYY-MM-DD"),
                        "sessiondate",
                        initialValues
                      );
                    }}
                    disabled={isDisabled}
                    slotProps={{
                      textField: {
                        required: true,
                      },
                    }}
                    onBlur={handleBlur}
                    shouldDisableDate={disableFutureDates}
                  />
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  {/* <TimePicker
                      label="Session start Time"
                      sx={{ gridColumn: "span 2",...themeStyles.textField }}
                      fullWidth
                      variant="filled"
                      className="animated-input"
                      name="sessionstarttime"
                      value={values.sessionstarttime}
                      onChange={(newValue) => {
                        handleChange({
                          target: {
                            name: "sessionstarttime",
                            value: newValue,
                          },
                        });
                      }}
                      onBlur={handleBlur}
                    /> */}
                  <MultiInputTimeRangeField
                    name="sessiontime"
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                    fullWidth
                    value={
                      values.sessiontime && values.sessiontime.length === 2
                        ? [
                            values.sessiontime[0]
                              ? dayjs(values.sessiontime[0])
                              : null,
                            values.sessiontime[1]
                              ? dayjs(values.sessiontime[1])
                              : null,
                          ]
                        : [null, null]
                    }
                    onChange={(newValue) => {
                      setFieldValue("sessiontime", newValue);
                      handleFieldChange(
                        newValue?.[0]?.format("HH:mm") || "",
                        "sessionstarttime",
                        initialValues
                      );
                      handleFieldChange(
                        newValue?.[1]?.format("HH:mm") || "",
                        "sessionendtime",
                        initialValues
                      );
                    }}
                    disabled={isDisabled}
                    slotProps={{
                      textField: ({ position }) => ({
                        label:
                          position === "start"
                            ? "Session start time"
                            : "Session end time",
                        required: true,
                      }),
                    }}
                  />
                </LocalizationProvider>
                {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      label="Session End Time"
                      sx={{ gridColumn: "span 2",...themeStyles.textField }}
                      fullWidth
                      variant="filled"
                      className="animated-input"
                      name="sessionendtime"
                      value={values.sessionendtime}
                      onChange={(newValue) => {
                        handleChange({
                          target: {
                            name: "sessionendtime",
                            value: newValue,
                          },
                        });
                      }}
                      onBlur={handleBlur}
                    />
                  </LocalizationProvider> */}
                <FormControl
                  fullWidth
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                  <Autocomplete
                    fullWidth
                    options={placeOfService} // Assuming 'placeOfService' is the array of options
                    autoHighlight
                    getOptionLabel={(option) => option.toString()} // Assuming
                    value={values.placeofservicecode}
                    onChange={(event, newValue) => {
                      // Create a synthetic event to pass to handleChange
                      handleChange({
                        target: {
                          name: "placeofservicecode",
                          value: newValue || "", // Use an empty string if newValue is null
                        },
                      });
                      handleFieldChange(
                        newValue || "",
                        "placeofservicecode",
                        initialValues
                      );
                    }}
                    disabled={isDisabled}
                    onBlur={handleBlur} // Assuming you have a handleBlur function for onBlur event
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Place of service"
                        variant="filled"
                        className="animated-input"
                        required
                        inputProps={{
                          ...params.inputProps,
                          "aria-label": "Select a place of service",
                        }}
                      />
                    )}
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                  />
                </FormControl>

                <TextField
                  fullWidth
                  variant="filled"
                  className="animated-input"
                  label="Other Place of Service (Maxlength: 30)"
                  onBlur={handleBlur}
                  onChange={(event) => handleInputChange(event, setFieldValue)}
                  disabled={isDisabled}
                  required={values.placeofservicecode === "Other"}
                  value={values.otherplaceofservice}
                  name="otherplaceofservice"
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                  inputProps={{
                    maxLength: 30,
                  }}
                />
                <FormControl
                  fullWidth
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                  <Autocomplete
                    fullWidth
                    options={moDifier} // Assuming 'moDifier' is the array of options
                    autoHighlight
                    getOptionLabel={(option) => option} // Assuming 'option' is a string you want to display
                    value={values.modifier || ""} // Fallback to an empty string if values.modifier is undefined
                    onChange={(event, newValue) => {
                      // Create a synthetic event to pass to handleChange
                      handleChange({
                        target: {
                          name: "modifier",
                          value: newValue || "", // Use an empty string if newValue is null
                        },
                      });
                      handleFieldChange(
                        newValue || "",
                        "modifier",
                        initialValues
                      );
                    }}
                    disabled={isDisabled}
                    onBlur={handleBlur} // Assuming you have a handleBlur function for onBlur event
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Modifier"
                        variant="filled"
                        className="animated-input"
                        required
                        inputProps={{
                          ...params.inputProps,
                          "aria-label": "Select a modifier",
                        }}
                      />
                    )}
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                    renderOption={(props, option) => (
                      <MenuItem {...props} key={option} value={option}>
                        {option}
                      </MenuItem>
                    )}
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                  <Autocomplete
                    fullWidth
                    options={procedureCode} // Assuming 'procedureCode' is the array of options
                    autoHighlight
                    getOptionLabel={(option) => option} // Assuming 'option' is a string you want to display
                    value={values.procedurecode || ""} // Fallback to an empty string if values.procedurecode is undefined
                    onChange={(event, newValue) => {
                      // Create a synthetic event to pass to handleChange
                      handleChange({
                        target: {
                          name: "procedurecode",
                          value: newValue || null, // Use an empty string if newValue is null
                        },
                      });
                    }}
                    onBlur={handleBlur} // Assuming you have a handleBlur function for onBlur event
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Procedure Code"
                        variant="filled"
                        className="animated-input"
                        required
                        inputProps={{
                          ...params.inputProps,
                          "aria-label": "Select a procedure code",
                        }}
                      />
                    )}
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                    disabled={true}
                    renderOption={(props, option) => (
                      <MenuItem {...props} key={option} value={option}>
                        {option}
                      </MenuItem>
                    )}
                  />
                </FormControl>

                <FormControl
                  fullWidth
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                  <Autocomplete
                    fullWidth
                    options={diagnosisCode} // Assuming 'diagnosisCode' is the array of options
                    autoHighlight
                    getOptionLabel={(option) => option} // Assuming 'option' is a string you want to display
                    value={values.diagnosiscode1 || ""}
                    disabled={isDisabled} // Fallback to an empty string if values.diagnosiscode1 is undefined
                    onChange={(event, newValue) => {
                      // Create a synthetic event to pass to handleChange
                      handleChange({
                        target: {
                          name: "diagnosiscode1",
                          value: newValue || "", // Use an empty string if newValue is null
                        },
                      });
                      handleFieldChange(
                        newValue || "",
                        "diagnosiscode1",
                        values
                      );
                    }}
                    onBlur={handleBlur} // Assuming you have a handleBlur function for onBlur event
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Diagnosis Code 1"
                        variant="filled"
                        className="animated-input"
                        required
                        inputProps={{
                          ...params.inputProps,
                          "aria-label": "Select a diagnosis code",
                        }}
                      />
                    )}
                    sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                  />
                </FormControl>

                <TextField
                  fullWidth
                  variant="filled"
                  className="animated-input"
                  label="Other Diagnosis Code (Maxlength: 30)"
                  onBlur={handleBlur}
                  onChange={(event) => handleInputChange(event, setFieldValue)}
                  name="otherdiagnosiscode"
                  value={values.otherdiagnosiscode}
                  required={values.diagnosiscode1 === "Other"}
                  inputProps={{
                    maxLength: 30,
                  }}
                  disabled={isDisabled}
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                />

                <FormGroup
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                  <FormLabel component="legend">Session Participant</FormLabel>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isDisabled}
                        checked={sessionparticipantsState.child}
                        onChange={handleSessionParticipants}
                        name="child"
                      />
                    }
                    label="Child"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isDisabled}
                        checked={sessionparticipantsState.parent}
                        onChange={handleSessionParticipants}
                        name="parent"
                      />
                    }
                    label="Parent"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isDisabled}
                        checked={sessionparticipantsState.bcba}
                        onChange={handleSessionParticipants}
                        name="bcba"
                      />
                    }
                    label="BCBA"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isDisabled}
                        checked={sessionparticipantsState.behaviourtechnician}
                        onChange={handleSessionParticipants}
                        name="behaviourtechnician"
                      />
                    }
                    label="Behaviour Technician"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isDisabled}
                        checked={sessionparticipantsState.other}
                        onChange={handleSessionParticipants}
                        name="other"
                      />
                    }
                    label="Other"
                  />
                  {sessionparticipantsState.other && (
                    <TextareaAutosize
                      fullWidth
                      variant="filled"
                      className="animated-input"
                      placeholder="Type in here… (Maxlength: 30)"
                      name="othersessionparticipants"
                      value={values.othersessionparticipants}
                      onChange={(event) =>
                        handleInputChange(event, setFieldValue)
                      }
                      minRows={2}
                      disabled={isDisabled}
                      maxRows={2}
                      required={sessionparticipantsState.other}
                      inputProps={{
                        maxLength: 30,
                      }}
                    />
                  )}
                </FormGroup>
                <FormGroup
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                  <FormLabel component="legend">Training Provided</FormLabel>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isDisabled}
                        checked={moreInfoState.optiona}
                        onChange={handleMoreInformation}
                        name="optiona"
                      />
                    }
                    label="BCBA Provided Parent/Training"
                  />

                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={isDisabled}
                        checked={moreInfoState.otherinfocheckbox}
                        onChange={handleMoreInformation}
                        name="otherinfocheckbox"
                      />
                    }
                    label="Other"
                  />
                  {moreInfoState.otherinfocheckbox && (
                    <TextareaAutosize
                      fullWidth
                      variant="filled"
                      className="animated-input"
                      placeholder="Type in here… (Maxlength: 30)"
                      name="othertrainingprovided"
                      value={values.othertrainingprovided}
                      onChange={(event) =>
                        handleInputChange(event, setFieldValue)
                      }
                      minRows={2}
                      disabled={isDisabled}
                      maxRows={3}
                      required={moreInfoState.otherinfocheckbox}
                      inputProps={{
                        maxLength: 30,
                      }}
                    />
                  )}
                </FormGroup>
                <FormGroup
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                  <FormLabel component="legend">
                    BCBA Provided Training to Parent/Caregiver On
                  </FormLabel>
                  {Object.entries(bcbaTrainingState).map(([key, value]) => (
                    <FormControlLabel
                      key={key}
                      control={
                        <Checkbox
                          checked={value}
                          disabled={isDisabled}
                          onChange={handleBcbaTrainingChange}
                          name={key}
                        />
                      }
                      label={trainingLabels[key]}
                    />
                  ))}
                  {bcbaTrainingState.others && (
                    <TextareaAutosize
                      fullWidth
                      variant="filled"
                      className="animated-input"
                      placeholder="Type in here… (Maxlength: 30)"
                      name="otherbcbasapplied"
                      disabled={isDisabled}
                      value={values.otherbcbasapplied}
                      onChange={(event) =>
                        handleInputChange(event, setFieldValue)
                      }
                      minRows={2}
                      maxRows={3}
                      required={bcbaTrainingState.others}
                      inputProps={{ maxLength: 30 }}
                    />
                  )}
                </FormGroup>
                <FormGroup
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                  <FormLabel component="legend">
                    Activities Performed by BCBA During Parent/Caregiver
                    Training
                  </FormLabel>
                  {Object.entries(bcbaActivitiesState).map(([key, value]) => (
                    <FormControlLabel
                      key={key}
                      control={
                        <Checkbox
                          disabled={isDisabled}
                          checked={value}
                          onChange={handleBcbaActivitiesChange}
                          name={key}
                        />
                      }
                      label={activitiesLabels[key]}
                    />
                  ))}
                </FormGroup>

                <FormGroup
                  fullWidth
                  sx={{ gridColumn: "span 4", ...themeStyles.textField }}>
                  <FormLabel component="legend">
                    Parent/Caregiver Training Goals Addressed (Maxlength: 1000)
                    <Tooltip title="Help">
                      <IconButton
                        onClick={() =>
                          handleImageModal("traininggoaladdressed.jpeg")
                        }>
                        <HelpOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  </FormLabel>
                  <TextField
                    fullWidth
                    variant="filled"
                    className="animated-input"
                    onBlur={handleBlur}
                    onChange={(event) =>
                      handleInputChange(event, setFieldValue)
                    }
                    required
                    disabled={isDisabled}
                    value={values.traininggoaladdressed}
                    name="traininggoaladdressed"
                    sx={{ gridColumn: "span 4", ...themeStyles.textField }}
                    rows={5}
                    multiline
                    inputProps={{ maxLength: 1000 }}
                  />
                </FormGroup>

                <FormGroup
                  fullWidth
                  sx={{ gridColumn: "span 4", ...themeStyles.textField }}>
                  <FormLabel component="legend">
                    Session Summary (Maxlength: 2500)
                    <Tooltip title="Help">
                      <IconButton
                        onClick={() => handleImageModal("sessionsummary.png")}>
                        <HelpOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  </FormLabel>
                  <TextField
                    fullWidth
                    variant="filled"
                    className="animated-input"
                    onBlur={handleBlur}
                    onChange={(event) =>
                      handleInputChange(event, setFieldValue)
                    }
                    disabled={isDisabled}
                    value={values.sessionsummary}
                    name="sessionsummary"
                    sx={{ gridColumn: "span 4", ...themeStyles.textField }}
                    rows={5}
                    multiline
                    inputProps={{ maxLength: 2500 }}
                    required
                  />
                </FormGroup>
                <FormGroup
                  fullWidth
                  sx={{ gridColumn: "span 4", ...themeStyles.textField }}>
                  <FormLabel component="legend">
                    Parent/Caregiver Responses (Maxlength: 1000)
                    <Tooltip title="Help">
                      <IconButton
                        onClick={() => handleImageModal("parentresponse.jpeg")}>
                        <HelpOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  </FormLabel>
                  <TextField
                    fullWidth
                    variant="filled"
                    className="animated-input"
                    onBlur={handleBlur}
                    onChange={(event) =>
                      handleInputChange(event, setFieldValue)
                    }
                    required
                    disabled={isDisabled}
                    value={values.parentresponse}
                    name="parentresponse"
                    sx={{ gridColumn: "span 4", ...themeStyles.textField }}
                    rows={5}
                    multiline
                    inputProps={{ maxLength: 1000 }}
                  />
                </FormGroup>

                <FormGroup
                  fullWidth
                  sx={{ gridColumn: "span 4", ...themeStyles.textField }}>
                  <FormLabel component="legend">
                    Progress/Lack of Progress (Maxlength: 1000)
                    <Tooltip title="Help">
                      <IconButton
                        onClick={() =>
                          handleImageModal("barriersduringsession.jpeg")
                        }>
                        <HelpOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  </FormLabel>
                  <TextField
                    fullWidth
                    variant="filled"
                    className="animated-input"
                    onBlur={handleBlur}
                    onChange={(event) =>
                      handleInputChange(event, setFieldValue)
                    }
                    required
                    disabled={isDisabled}
                    value={values.barriersduringsession}
                    name="barriersduringsession"
                    sx={{ gridColumn: "span 4", ...themeStyles.textField }}
                    rows={5}
                    multiline
                    inputProps={{ maxLength: 1000 }}
                  />
                </FormGroup>
                <FormGroup
                  fullWidth
                  sx={{ gridColumn: "span 4", ...themeStyles.textField }}>
                  <FormLabel component="legend">
                    Plan for Next Session (Maxlength: 1000)
                    <Tooltip title="Help">
                      <IconButton
                        onClick={() =>
                          handleImageModal("planfornextvisit.png")
                        }>
                        <HelpOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  </FormLabel>
                  <TextField
                    fullWidth
                    variant="filled"
                    className="animated-input"
                    disabled={isDisabled}
                    onBlur={handleBlur}
                    onChange={(event) =>
                      handleInputChange(event, setFieldValue)
                    }
                    value={values.planfornextsession}
                    name="planfornextsession"
                    sx={{ gridColumn: "span 4", ...themeStyles.textField }}
                    rows={5}
                    inputProps={{ maxLength: 1000 }}
                    required
                    multiline
                  />
                </FormGroup>
                <TextField
                  fullWidth
                  variant="filled"
                  disabled={isDisabled}
                  className="animated-input"
                  label="Parent or Caregiver Title (Maxlength: 30)"
                  onBlur={handleBlur}
                  value={values.parentorcaregivertitle}
                  onChange={(event) => handleInputChange(event, setFieldValue)}
                  name="parentorcaregivertitle"
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}
                  inputProps={{ maxLength: 30 }}
                />
                <FormGroup
                  fullWidth
                  sx={{
                    gridColumn: "span 2",
                    ...themeStyles.textField,
                  }}></FormGroup>
                <FormGroup
                  sx={{ gridColumn: "span 2", ...themeStyles.textField }}>
                  <FormLabel component="legend">BCBA's signature</FormLabel>
                  {supervisorSignatureImage.image ? (
                    <Box display="flex" alignItems="center">
                      <img
                        src={supervisorSignatureImage.image}
                        alt="Supervisor Signature"
                        height="100"
                        width="150"
                      />
                      {checkPermission(
                        SESSION_NOTE_97155,
                        DELETE,
                        checkOwner(values),
                        values.sessionstatus
                      ) && (
                        <IconButton
                          color="error"
                          onClick={() => handleDeleteSignature("Supervisor")}>
                          <DeleteIcon />
                        </IconButton>
                      )}
                    </Box>
                  ) : (
                    !isDisabled && (
                      <>
                        <FormControlLabel
                          control={
                            <SignaturePad
                              ref={sigSupervisor}
                              onEnd={handleSupervisorSignature}
                              canvasProps={{
                                height: 200,
                                className: "sigCanvas",
                              }}
                            />
                          }
                        />
                        <FormControlLabel
                          control={
                            <div>
                              <Button
                                onClick={clearSupervisorSignature}
                                // fullWidth
                                //  fullWidth
                                variant="contained"
                                color="primary"
                                margin="10px"
                                sx={{
                                  gridColumn: "span 1",
                                  ...buttonStyle,
                                }}>
                                Clear
                              </Button>
                            </div>
                          }
                        />
                      </>
                    )
                  )}
                </FormGroup>
                {!supervisorSignatureImage.image && !isDisabled ? (
                  <DatePicker
                    fullWidth
                    label="BCBA Signature Date"
                    variant="filled"
                    value={
                      values.supervisorsignaturedate ||
                      supervisorSignatureImage.date ||
                      null
                    }
                    onChange={(value) =>
                      setFieldValue("supervisorsignaturedate", value)
                    }
                    name="supervisorsignaturedate"
                    InputLabelProps={{ shrink: true }}
                    disabled={!isSignaturePresent}
                    slotProps={{
                      textField: {
                        error:
                          touched.supervisorsignaturedate &&
                          Boolean(errors.supervisorsignaturedate),
                        helperText:
                          touched.supervisorsignaturedate &&
                          errors.supervisorsignaturedate,
                        required: !sigSupervisor?.current?.isEmpty(),
                        sx: {
                          gridColumn: "span 2",
                          ...themeStyles.textField,
                        },
                      },
                    }}
                  />
                ) : (
                  <></>
                )}
              </Box>

              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  onClick={() => {
                    handleGoBack();
                  }}
                  color="secondary"
                  sx={{ ...buttonStyle }}
                  variant="contained"
                  style={{ marginRight: "10px" }}>
                  Go Back
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  sx={{ ...buttonStyle }}
                  variant="contained"
                  style={{ marginRight: "10px" }}
                  disabled={isDisabled}
                  onClick={(e) => {
                    e.preventDefault(); // Prevent default form submission
                    handleSaveAsDraft(values, { resetForm });
                  }} // pass the values directly
                >
                  Save as draft
                </Button>

                <Button
                  type="submit"
                  color="secondary"
                  sx={{ ...buttonStyle }}
                  variant="contained"
                  disabled={isDisabled}
                  onClick={(e) => {
                    e.preventDefault(); // Prevent default form submission
                    handleApprove(values, { resetForm });
                  }}>
                  Save as Approve
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    );
  }
};

const checkoutSchema = yup.object().shape({});

export default SessionNote97156;
